import { render, staticRenderFns } from "./ProductsListContainer.vue?vue&type=template&id=15bc06e7"
import script from "./ProductsListContainer.vue?vue&type=script&lang=js"
export * from "./ProductsListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports